module.exports = __webpack_public_path__ + "img/E-WEB-Goal-17.fa21c62f.png";